<template>
  <v-tooltip
    bottom
    color="font"
    :class="{
      'text--disabled': true,
    }"
    :disabled="!isContentWrapped"
  >
    <template #activator="{ on }">
      <span v-on="on">
        <data-input v-model="computedValue" :data-type="dataType" :rules="rules" :disabled="disabled" />
      </span>
    </template>
    {{ computedValue }}
  </v-tooltip>
</template>

<script>
import isContentWrapped from '@/mixins/directives/isContentWrapped';

import DataInput from '@/components/DataInput';

export default {
  name: 'DictonariesEditingRow',
  mixins: [isContentWrapped],
  components: {
    DataInput,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
    rules: {
      type: Array,
      default: () => [v => !!v || this.$i18n.t('rules.required')],
    },
    dataType: {
      type: Object,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    contentWrappedData() {
      return {
        method: this.setIsContentWrapped,
        elGetter: this.elementGetter,
      };
    },
  },
  methods: {
    elementGetter(el) {
      return el.getElementsByTagName('input')[0];
    },
  },
};
</script>

<style lang="scss" scoped></style>
